/* --- Element identifiers ------------------------------------------------- */

export const ACTION_MODAL_ID = {
  DELETE_GROUP: "delete-group",
  REMOVE_STUDENT_FROM_GROUP: "remove-student-from-group",
  REMOVE_SUBJECT_FROM_GROUP: "remove-subject-from-group",
  REQUEST_TEACHER_ACCESS: "request-teacher-access",
  ADD_BOOK_TO_COURSE: "add-book-to-course",
  DELETE_COURSE_CONTENT: "delete-course-content",
  OWN_CONTENT_MODAL: "own-content-modal",
  CHAPTER_DROPDOWN_MODAL: "chapter-dropdown-modal",
  ADD_COURSE_FILE_MODAL: "add-course-file-modal",
  NEW_ASSIGNMENT_MODAL: "new-assignment-modal",
  EDIT_ASSIGNMENT_MODAL: "edit-assignment-modal",
  EXAM_IMAGE_MODAL: "exam-image-modal",
  SUBMIT_ASSIGNMENT_ANSWER_MODAL: "confirm-assignment-answers",
  USER_FEEDBACK_MODAL: "user-feedback-modal",
  TEACHER_COURSE_START_NOTICE_MODAL: "teacher-course-start-notice-modal",
  NEW_PREVIOUS_COURSE_PREVIEW: "new-previous-course-preview",
  EDIFY_CROSS_LINK_CONTENT: "edify-cross-link-content",
  RATING_POPUP: "rating-popup",
  EXERCISE_SLIDE: "exercise-slide",
};

export const ASSIGNMENT_QUESTIONS_WITH_DESCRIPTION = ["performQuestion"];

export const WIDGET_ID = "launcher";

/* --- Content types ------------------------------------------------------- */

export const CONTENT_TYPES = {
  course: "course",
  chapter: "chapter",
  assignment: "assignment",
  asset: "asset",
  courseAsset: "courseAsset",
  chapterTest: "chapterTest",
  practiceTest: "practiceTest",
  personalTest: "personalTest",
};

export const FILE_EXTENSION = {
  "application/pdf": ".pdf",
  "application/msword": ".doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": ".docx",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template": ".dotx",
  "application/vnd.ms-word.document.macroEnabled.12": ".docm",
  "application/vnd.ms-word.template.macroEnabled.12": ".dotm",
  "application/vnd.ms-excel": ".xls",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ".xlsx",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.template": ".xltx",
  "application/vnd.ms-excel.sheet.macroEnabled.12": ".xlsm",
  "application/vnd.ms-excel.template.macroEnabled.12": ".xltm",
  "application/vnd.ms-excel.addin.macroEnabled.12": ".xlam",
  "application/vnd.ms-excel.sheet.binary.macroEnabled.12": ".xlsb",
  "application/vnd.ms-powerpoint": ".ppt",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": ".pptx",
  "application/vnd.openxmlformats-officedocument.presentationml.template": ".potx",
  "application/vnd.openxmlformats-officedocument.presentationml.slideshow": ".ppsx",
  "application/vnd.ms-powerpoint.addin.macroEnabled.12": ".ppam",
  "application/vnd.ms-powerpoint.presentation.macroEnabled.12": ".pptm",
  "application/vnd.ms-powerpoint.template.macroEnabled.12": ".potm",
  "application/vnd.ms-powerpoint.slideshow.macroEnabled.12": ".ppsm",
  "application/vnd.ms-access": ".mdb",
  "application/zip": ".zip",
};

export const ASSETS_TYPES = {
  document: "document",
  link: "link",
  video: "video",
  audio: "audio",
};

export const dashProgressBarTypes = {
  SINGLE_COLOR: "singleColor",
  FIVE_DASHES: "fiveDashes",
  PROGRESS_COLOR: "progressColor",
};

export const GROUP_STATISTICS_TYPE = {
  results: "results",
  progress: "progress",
};

export const PAYMENT_METHODS = {
  ideal: "ideal",
  creditCard: "credit-card",
};

export const COURSE_EDITOR_TYPES = {
  chapters: "chapters",
  assignments: "assignments",
  assets: "assets",
};

export const DASHBOARD_TABLE_TYPES = {
  results: "results",
  assignments: "assignments",
};

export const NEW_COURSE_SOURCE = {
  NOORDHOFF: "noordhoff",
};

export const BOOK_MODAL_STATE = {
  chapters: "chapters",
  assignments: "assignments",
};

export const COURSE_MODAL_STATE = {
  chapters: "chapters",
  assignments: "assignments",
};

export const DASHBOARD_ASSIGNMENT_TABS = {
  answers: "answers",
  description: "description",
};

export const ASSIGNMENT_STATUS = {
  notStarted: "notStarted",
  finished: "finished",
  notReviewed: "notReviewed",
  reviewed: "reviewed",
  reviewedPassed: "reviewedPassed",
  reviewedFailed: "reviewedFailed",
  WIP: "WIP",
};

export const QUESTION_TYPE = {
  chapter: "chapter",
  personal: "personal",
};

export const WEEK_STATUS = {
  completed: "completed",
  inProgress: "inProgress",
  start: "start",
  nextWeek: "nextWeek",
  onlyExtraMaterial: "onlyExtraMaterial",
  unknownStatus: "unknownStatus",
};

export const WEEK_STATUS_MESSAGES = {
  completed: "completed.message",
  start: "start.message",
  inProgress: "inProgress.message",
  pendingAssignments: "inProgress.needPassAssignments",
  pendingAssignmentsAndTests: "inProgress.needPassAssignments&Tests",
  pendingTests: "inProgress.needPassTest",
  InProgressOnlyExtraMaterial: "inProgress.onlyExtraMaterial",
  nextWeek: "nextWeek.message",
  nextWeekOnlyExtraMaterial: "nextWeek.onlyExtraMaterial",
  unknownStatus: "unknownStatus.message",
};

export const CHAPTER_QUESTION_TYPE = {
  openQuestion: "openQuestion",
};

export const ASSIGNMENT_QUESTION_TYPE = {
  performQuestion: "performQuestion",
  openQuestion: "openQuestion",
};

export const SEARCH_CONTENT_TYPE = {
  theory: "theory",
  slide: "slide",
};

/* --- Tab list ------------------------------------------------------------ */

export const ASSIGNMENT_TABS = {
  description: "description",
  questions: "questions",
};

export const PERSONAL_RESULTS_TABS = {
  RESULTS: "results",
  QUESTIONS: "questions",
};

export const CHAPTER_TABS = {
  SLIDE: "slide",
  THEORY: "theory",
  EXERCISE: "exercise",
  ASSET: "asset",
  GO_TO: "go_to",
};

export const CHAPTER_NAV_ORDER = [CHAPTER_TABS.SLIDE, CHAPTER_TABS.ASSET, CHAPTER_TABS.EXERCISE];
export const DIRECTION = {
  FORWARD: +1,
  BACKWARDS: -1,
};

export const RESULTS = {
  MINIMUM: 50,
};

export const CHAPTER_NAV_REVERSE_ORDER = [...CHAPTER_NAV_ORDER].reverse();
/* --- Icon reference ------------------------------------------------------ */

export const CHAPTER_TABS_ICONS = {
  slide: "icon-layers",
  theory: "icon-theorie",
  exercise: "icon-practice",
  assets: "icon-video",
  example: "icon-example",
  notes: "icon-teacher",
};

export const ASSIGNMENT_TABS_ICONS = {
  description: "icon-casus",
  questions: "icon-question",
};

/* --- Color reference ----------------------------------------------------- */

export const COLORS = {
  secondary: "#0083C9",
  success: "#4DC591",
  failure: "#E42526",
  black: "#292F3B",
  progress: {
    completed: "#7ED321",
    todo: "#D6DDE6",
    failure: "#E42526",
    default: "#97A1B8",
  },
  star: {
    success: "#5BDD87",
    medium: "#F0B500",
    failure: "#D80000",
    default: "#DADADA",
  },
  scores: {
    success: "#5BDD87",
    default: "#DADADA",
    failure: "#F0B500",
  },
  statistics: {
    correct: "#54C895",
    incorrect: "#D80000",
    default: "#EDEDED",
  },
};

export const NOT_ANSWERED_COLOR = "#EDEDED";

export const DEFAULT_ANSWER_COLOR_SET = ["#54C895", "#EC9A8D", "#CB412C", "#451E18"];

/* --- Misc. constants ----------------------------------------------------- */

export const DEFAULT_WEEK_TITLE = "Add a week title";

export const DEFAULT_INCREMENT = {
  type: "w",
  quantity: 0,
};

export const dateTypes = {
  sideMenu: "D MMMM, YYYY",
};

export const NOT_VALID_VALUES = [null, undefined, "", []];

export const EXPIRED_SESSION_KEY = "sessionExpired";

export const PLAYER_TRANSLATIONS = {
  submit: "Indienen",
  feedback_bad: "Fout",
  feedback_good: "Goed gedaan!",
  feedback_incomplete: "Incompleet",
  feedback_incomplete_body: "Je hebt niet alle juiste antwoorden geselecteerd.",
  solutionExplained_title: "Oplossing uitgelegd",
  correctAnswer_title: "Goed antwoord",
  next: "Volgende",
};
